<template>
    <div>
     <div class="goods-list-wrap">
         <div v-if="couponsList[0] && (couponsList[0].coupon_type == 2)">
            <router-link :to="{ path: '/detail/' + item.id }" class="page-inline-block template-wrap" v-for="(item,index) in shopList" :key="index">
                <img class="topImage" :src="item.image" />
                <div class="bottomInfo">
                    <p class="line2 titles">{{ item.store_name }}</p>
                    <div class="acea-row row-middle row-between price-wrap">
                        <p>
                            <span class="price">&nbsp;</span>
                            <span class="sales">&nbsp;</span>
                        </p>
                        <img class="icon" :src="require('@/assets/images/index-shop-list-icon.png')" />
                    </div>
                </div>
            </router-link>
         </div>
         <div v-else>
            <router-link :to="{ path: '/detail/' + item.id }" class="page-inline-block template-wrap" v-for="(item,index) in shopList" :key="index">
                <img class="topImage" :src="item.image" />
                <div class="bottomInfo">
                    <p class="line2 titles">{{ item.store_name }}</p>
                    <div class="acea-row row-middle row-between price-wrap">
                        <p>
                            <span class="price">{{ item.price }}</span>
                            <span class="sales">已售{{ item.sales }}{{ item.unit_name }}</span>
                        </p>
                        <img class="icon" :src="require('@/assets/images/index-shop-list-icon.png')" />
                    </div>
                </div>
            </router-link>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "GoodsList",
    data: function() {
        return {

        }
    },
    props: {
        shopList: {
            type: Array,
            default: []
        },
        couponsList: {
            type: Array,
            default: []
        }
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.goods-list-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0.22rem;
}
.template-wrap {
    width: 3.36rem;
    min-height: 4.8rem;
    background: #fff;
    margin: 0.08rem;
    border-radius: 0.16rem;
    overflow: hidden;
    .topImage{
        width: 3.36rem;
        height: 3.36rem;
        display: block;
    }
    .bottomInfo {
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        padding: 0.18rem;
        .titles {
            font-size: 0.28rem;
            min-height: .7rem;
        }
        .price-wrap {
            margin-top: 0.08rem;
        }
        .icon {
            width: 0.28rem;
            height: 0.28rem;
        }
        .price {
            font-size: 0.36rem;
            color:#F64A44;
        }
        .sales {
            font-size: 0.24rem;
            color: #BEBEBE;
            margin-left: 0.08rem;
        }
    }
}
</style>